import { useQuery } from '@tanstack/react-query';
import { getMetricsCurrencies, IMetricsCurrencies } from '../services/queries/MaggieMetricsQueries';
import { defaultCurrency } from '../services/state/AppConfigStateJ';

export const MetricsCurrenciesQueryKey = 'metricsCurrencies';

const usdOnly: IMetricsCurrencies = { computed: [defaultCurrency], fundDefaults: {} };

/**
 * The currencies metrics are computed in (every fund's reporting currency plus USD). USD alone
 * until loaded; `isLoaded` tells a placeholder from a real USD-only tenant.
 */
export function useMetricsCurrencies(): IMetricsCurrencies & { isLoaded: boolean } {
  const { data } = useQuery({
    queryKey: [MetricsCurrenciesQueryKey],
    queryFn: getMetricsCurrencies,
    staleTime: 60_000,
  });
  return { ...(data ?? usdOnly), isLoaded: data !== undefined };
}
